import axios from 'axios';
import * as types from './types';
// import * as FileSaver from "file-saver";
// import moment from 'moment';

export const loginAction = (username, password,{onSuccess,onFailure}) => {
    return function (dispatch) {
        axios.post(types.API_URL + '/admin/v1/disbursement/login', {
            userName: username,
            password: password
        })
            .then(function (response) {
                dispatch({
                    type: types.LOGIN_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response);
            })
            .catch(function (error) {
                dispatch({
                    type: types.LOGIN_FAILURE_ACTION,
                    payload: error
                });
                onFailure();
            });
    };
}

export const logoutAction = (email) => {
    return function (dispatch) {
        try {
            dispatch({
                type: types.LOGOUT_SUCCESS_ACTION,
            });
        }
        catch (error) {
            dispatch({
                type: types.LOGIN_FAILURE_ACTION,
                payload: error
            });
        }
    };

}

export const resetpassword = (audits, auditsType, masterDataId) => {
    return function (dispatch) {

    };
};
